<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          :fetch-data="fetchCommittees"
          :create-allowed="isPowerUserOrAdministrator"
          title="Commissions"
          @create="create"
          @row-clicked="committeeRowClicked"
        >
          <el-table-column label="Nom" min-width="60" property="name" />
          <el-table-column label="Sigle" min-width="10" property="acronym" />
          <el-table-column
            v-if="canUserAccessPrivateData"
            label="Statut"
            min-width="10"
            property="status"
          />
          <el-table-column
            v-if="canUserAccessPrivateData"
            label="Annuaire public"
            min-width="20"
          >
            <div slot-scope="slotScope">
              {{ slotScope.row.isOfficial ? 'Oui' : 'Non' }}
            </div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import {
  canUserAccessPrivateData,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
  },
  data() {
    return {
      searchText: '',
    };
  },
  computed: {
    canUserAccessPrivateData,
    isPowerUserOrAdministrator,
  },
  created() {
    if (this.$route.params && this.$route.params.searchText) {
      this.searchText = this.$route.params.searchText;
    }
  },
  methods: {
    committeeRowClicked(row) {
      this.$router.push({
        name: 'CommitteeDetails',
        params: { id: row.id, newCommitteeCreation: false },
      });
    },
    fetchCommittees(pageNumber, pageSize, searchText) {
      let url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/committeeEntities`;
      const dto = this.canUserAccessPrivateData
        ? 'committeeDTO'
        : 'committeePublicDTO';

      // If a searchText is defined within the component (coming from the route parameter in created method), fetch committees corresponding to that text
      if (this.searchText) {
        searchText = this.searchText;
        // Reset component's searchText
        this.searchText = '';
      }
      if (searchText) {
        if (this.canUserAccessPrivateData) {
          url += '/search/fulltext';
        } else {
          url += '/search/publicFulltext';
        }

        url += `?projection=${dto}&name=${searchText}&acronym=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        if (!this.canUserAccessPrivateData) {
          url += '/search/public';
        }

        url += `?projection=${dto}&page=${pageNumber - 1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.committeeEntities
          ? response.data._embedded.committeeEntities
          : [],
        page: response.data.page,
      }));
    },
    create() {
      this.$router.push({
        name: 'CommitteeDetails',
        params: { id: 0, newCommitteeCreation: true },
      });
    },
  },
};
</script>

<style scoped></style>
